import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  onKeydown(e) {
    if (e.key.toLowerCase() === "f" && !e.metaKey && !e.ctrlKey && !e.altKey) {
      if (document.activeElement.tagName === "INPUT") return
      e.preventDefault()
      this.toggle()
    }
  }

  toggle() {
    this.panelTarget.classList.toggle("hidden")
  }
}
